module.exports = __webpack_public_path__ + "img/5.9a049e96.svg";